<template>
  <div class="form-group">
    <label v-if="labelName"> {{this.labelName}} </label>
    <input
      type="file"
      v-on:change="handleFileUpload()"
      id="inputFile4"
      multiple=""
      ref="file"
      name="photo"
    />
    <div class="input-group">
      <input
        type="text"
        readonly=""
        id="addon3"
        class="form-control"
        placeholder="with file chooser..."
      />
      <span class="input-group-btn input-group-sm">
        <button type="button" class="btn btn-fab btn-fab-mini">
          <i class="material-icons">attach_file</i>
        </button>
      </span>
    </div>
    <div v-if="FileMessage" class="alert-success" role="alert">{{FileMessage}}</div>
    <ul v-if="errorsdetails && errorsdetails.length">
      <li v-for="error in errorsdetails" :key="error.index">
        {{error.message}}
      </li>
    </ul>
  </div>
</template>
<script>
import CommonServices from '../../services/common-services'
export default {
  name: 'file-upload',
  props:['labelName'],
  data() {
    return {
      file: '',
      FileMessage:'',
      errorsdetails:[],
      image:{url:null,path:null}
    };
  },
  methods: {
       /*
        Submits the file to the server
      */
      submitFile(){
        let loader = this.$loading.show();
        /*
                Initialize the form data
            */
            let formData = new FormData();
              if (this.file.size > 1024 * 1024) {
                this.FileMessage = "File is too big"; 
                return;
              }
            /*
                Add the form data we need to submit
            */
            formData.append('photo', this.file);
            formData.append('upload_type','Genaral');
            formData.append('unique_key','5');
            CommonServices.upload_file(formData).then(
                 (responce) => {
              this.FileMessage = responce.data.message;
              if(responce.data.status){
                   this.image.url = responce.data.data.images.url;
                   this.image.path = responce.data.data.images.path;
                   this.$emit('imageUploadData', this.image)
              }
             
            },(error) => {
                //   this.loading = false;
                    this.FileMessage =
                        (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            ).catch(e => {
                this.errors.push(e)
                })
       setTimeout(() => {loader.hide()}, 1000)
      },

      /*
        Handles a change on the file upload
      */
    handleFileUpload() {
        
         this.file = this.$refs.file.files[0];
         this.submitFile();
    },
  },
};
</script>